module.exports = __webpack_public_path__ + "img/inverter_offline.87468484.png";